@if (pageLabels$ | async; as pageLabels) {
  <main class="gs-page">
    <div class="lookup-account-page">
      <div
        class="gradient-container lookup-account-section"
        [style]="'background:url(' + pageLabels.gradientBackgroundUrl + ')'"
      >
        <div class="lookup-account-form-container">
          <img [src]="pageLabels.gasSouthLogoLg" alt="Gas South 20 Years Logo" class="logo-image" />
          <app-notification [pageName]="pageName"></app-notification>
          <h1 class="lookup-account-account-header">{{ pageLabels.headerText }}</h1>
          <form [formGroup]="lookupAccountForm" (ngSubmit)="onSubmit()" class="lookup-account-form">
            <mat-form-field class="lookup-account-container" appearance="outline" subscriptSizing="dynamic">
              <mat-label id="accountNumberLabel">{{ pageLabels.lookupAccountNumberLabel }}</mat-label>
              <input
                matInput
                class="custom-input"
                formControlName="accountNumber"
                id="acctNumber"
                aria-labelledby="accountNumberLabel accountNumberError ConfirmAcctNumMinLengthErr acctNumInvalidErr"
                maxlength="10"
              />
              @if (lookupAccountForm.get("accountNumber")?.hasError("required")) {
                <mat-error id="accountNumberError">{{ pageLabels.accountNumberError }}</mat-error>
              } @else if (lookupAccountForm.get("accountNumber")?.hasError("minlength")) {
                <mat-error id="ConfirmAcctNumMinLengthErr">{{ pageLabels.accountNumberTenDigitError }}</mat-error>
              } @else if (lookupAccountForm.get("accountNumber")?.hasError("invalidAccount")) {
                <mat-error id="acctNumInvalidErr">{{ pageLabels.accountNumberTenDigitError }}</mat-error>
              }
            </mat-form-field>
            <mat-form-field class="lookup-account-container" appearance="outline" subscriptSizing="dynamic">
              <mat-label id="postalCodeLabel">{{ pageLabels.serviceAddressZipCodeText }}</mat-label>
              <input
                matInput
                class="custom-input"
                formControlName="postalCode"
                id="postalCode"
                aria-labelledby="postalCodeLabel postalCodeReqError postalCodeNumMinLengthErr postalCodeInvalid"
                maxlength="5"
              />
              @if (lookupAccountForm.get("postalCode")?.hasError("required")) {
                <mat-error id="postalCodeReqError">{{ pageLabels.zipCodeError }}</mat-error>
              } @else if (lookupAccountForm.get("postalCode")?.hasError("minlength")) {
                <mat-error id="postalCodeNumMinLengthErr">{{ pageLabels.zipCodeError }}</mat-error>
              } @else if (lookupAccountForm.get("postalCode")?.hasError("invalidZipCode")) {
                <mat-error id="postalCodeInvalid">{{ pageLabels.invalidZipCodeError }}</mat-error>
              }
            </mat-form-field>
            <button mat-flat-button class="gs-form-button-primary continue-button" color="primary">
              {{ pageLabels.buttonText }}
            </button>
          </form>
          <p class="help-text" [innerHTML]="pageLabels.helpText"></p>
          <a class="login-link" (click)="goToLogin()" href>{{ pageLabels.accountLogInLink }}</a>
        </div>
      </div>
      <div class="account-benefits lookup-account-section">
        <gs-icon-list [ListData]="pageLabels.accountBenefitsList" (DebugData)="logDebug($event)"></gs-icon-list>
      </div>
    </div>
  </main>
}
